import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ApkLoanInsuranceKKB = {};

ApkLoanInsuranceKKB.getSellingRateService = function (data) {
  const params = new URLSearchParams({
    maskassid: data?.maskassid || "",
    maskassbranch: data?.maskassbranch || "",
    incovtype: data?.incovtype || "",
    insarea: data?.insarea || "",
    assetcondition: data?.assetcondition || "",
    usagepolicy: data?.usagepolicy || "",
    coverageamount: data?.coverageamount || "",
  });

  return lossClient({
    url: `/ApkLoanInsuranceKKB/getSellingRate?${params.toString()}`,
    method: "get",
  });
};

ApkLoanInsuranceKKB.getAddService = function (data) {
  const dataIndex = data?.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data?.pageSize || 10,
    pageIndex: decrementIndex,
    applicationId: data?.applicationid || "",
  });

  return lossClient({
    url: `/ApkLoanInsuranceKKB/getAdd?${params.toString()}`,
    method: "get",
  });
};

ApkLoanInsuranceKKB.getEditService = function (data) {
  const dataIndex = data?.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data?.pageSize || 10,
    pageIndex: decrementIndex,
    applicationId: data?.applicationid || "",
  });

  return lossClient({
    url: `/ApkLoanInsuranceKKB/getEdit?${params.toString()}`,
    method: "get",
  });
};

ApkLoanInsuranceKKB.getPlansService = function (data) {
  const params = new URLSearchParams({
    maskassbranch: data?.maskassbranch || "",
    applicationid: data?.applicationid || "",
  });

  return lossClient({
    url: `/ApkLoanInsuranceKKB/getPlans?${params.toString()}`,
    method: "get",
  });
};

ApkLoanInsuranceKKB.opsiPerluasanServer = function (data) {
  return lossClient({
    url: `/ApkLoanInsuranceKKB/getOpsiPerluasan`,
    method: "post",
    data: data,
  });
};

ApkLoanInsuranceKKB.calculatePremiService = function (data) {
  return lossClient({
    url: `/ApkLoanInsuranceKKB/calculatePremi`,
    method: "post",
    data: data, 
  });
};


ApkLoanInsuranceKKB.getLifeInsuranceService = function (data) {
  
  const params = new URLSearchParams({
    maskassid: data?.maskassid || "",
    maskassbranchid: data?.maskassbranchid || "",
    coverageamount: data?.coverageamount || "",
    ageinmonths: data?.ageinmonths || "",
    tenor: data?.tenor || "",
  });

  return lossClient({
    url: `/ApkLoanInsuranceKKB/getLifeInsurance?${params.toString()}`,
    method: "get",
  });
};

ApkLoanInsuranceKKB.getCreditInsuranceService = function (data) {
  
  const params = new URLSearchParams({
    maskassid: data?.maskassid || "",
    maskassbranchid: data?.maskassbranchid || "",
    coverageamount: data?.coverageamount || "", 
  });

  return lossClient({
    url: `/ApkLoanInsuranceKKB/getCreditInsurance?${params.toString()}`,
    method: "get",
  });
};

ApkLoanInsuranceKKB.postAddInsuranceService = function (data) {
  return lossClient({
    url: `/ApkLoanInsuranceKKB/add`,
    method: "post",
    data: data,
  });
};

 
export default ApkLoanInsuranceKKB;
